import Loading from '../../../../Dashboards/Common/Loading';
import { IndicatorService } from './Indicator';
import { ServicesPerUnitPerYearChart } from './ServicesPerUnitPerYear';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Services = () => {
    const { chartData, isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="chats-indicators-side-by-side-dashboards">
                {chartData?.indicators.map((data) => (
                    <IndicatorService title={data.type} key={data.type} />
                ))}
            </div>
            <div className="charts-row-dashboards">
                <ServicesPerUnitPerYearChart />
            </div>
        </>
    );
};
